// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.changeisgroupsalearticle', {
        url:'/changeisgroupsalearticle',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/changeisgroupsalearticle/changeisgroupsalearticle.tpl.html',
            controller: 'SupportCaseChangeIsGroupSaleArticleController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseChangeIsGroupSaleArticleController($state, $scope, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.isEditing = false;
    vm.selectedProduct = {};
    vm.selectedProductVariant = {};
    vm.selectedProductCopy = {};
    vm.selectedProductVariantCopy = {};
    vm.isGroupSaleArticle = false;

    //Methods
    vm.recieveProduct = recieveProduct;
    vm.isAllowedToSave = isAllowedToSave;
    vm.startEditing = startEditing;
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;

    activate();

    function activate() {
    }

    function startEditing() {
        vm.isEditing = true;
    }
    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmUpdateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");
                SupportApiService.changeIsGroupSaleArticle({ articleId: vm.selectedProduct.id, isGroupSaleArticle: vm.isGroupSaleArticle }).then(function(response) {
                    cancelEditing();
                    ToasterService.showSuccess($translate.instant('support.isGroupArticleChanged'), $translate.instant('support.supportCase'));
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function cancelEditing() {
        vm.isEditing = false;
    }

    function recieveProduct(product) {
        vm.selectedProduct = product;
        loadSpinnerService.start("mainSpinner");
        SupportApiService.getProduct(vm.selectedProduct.id).then(function(response) {
            vm.selectedProduct = response;
            vm.isGroupSaleArticle = vm.selectedProduct.isGroupSaleArticle;
        }, function(error) {
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }

    function isAllowedToSave() {
        return vm.selectedProduct && vm.selectedProduct.id > 0;
    }
}

angular
    .module('supportcases.changeisgroupsalearticle', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseChangeIsGroupSaleArticleController', SupportCaseChangeIsGroupSaleArticleController);
